// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"6c90eba3","429":"98c9fc4a","450":"720d4427","611":"a9929a89","704":"3aed2dcd","787":"5245a0b7","898":"c46face9"}[chunkId] + ".chunk.js";
};